import * as React from 'react';
import { MainArea } from './mainArea';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { loadMasterPageData } from './../Actions/masterActions';
import { MainModel } from './../Models/mainModel';
import * as renderHtml from 'react-render-html';

declare function require(path: string);
declare var $;


export interface LayoutProps {
    children?: React.ReactNode;
    dispatch: (data: any) => void;
}

export class Layout extends React.Component<MainModel, MainModel> {

    public componentDidMount() {
        this.props.dispatch(loadMasterPageData());
    }

    public render() {

       return this.props.MasterModel == null ?
            <div className="main-loading-bg" ></div> :
            <div>
                <div className="topArea">

                    <nav className="navbar-default" role="navigation">

                        <div className="container">

                            <ul className="nav pull-left nav-pills">
                                <li><span className="glyphicon glyphicon-earphone"></span>{this.props.MasterModel.PhoneNumber}</li>
                                <li><a href={"mailto:" + this.props.MasterModel.EmailAddress }><span className="glyphicon glyphicon-envelope"></span>{this.props.MasterModel.EmailAddress}</a></li>
                                   </ul>

                            <ul className="nav nav-pills pull-right">
                                {
                                    this.props.MasterModel.DisplayFacebookLogo ?
                                    <li><a href={this.props.MasterModel.FacebookUrl} className="fa fa-facebook" target="_blank" ></a></li> :
                                    null}
                                {
                                    this.props.MasterModel.DisplayTwitterLogo ?
                                    <li><a href={this.props.MasterModel.TwitterUrl} className="fa fa-twitter" target="_blank" ></a></li> : null
                                }
                                {
                                    this.props.MasterModel.DisplayGooglePlusLogo ?
                                    <li><a href={this.props.MasterModel.GooglePlusUrl} className="fa fa-google-plus" target="_blank"></a></li> : null
                                }
                                {
                                    this.props.MasterModel.DisplayLinkedinLogo ?
                                    <li><a href={this.props.MasterModel.LinkedInUrl} className="fa fa-linkedin" target="_blank"></a></li> : null
                                }
                                {
                                    this.props.MasterModel.DisplayYoutubeLogo ?
                                    <li><a href={this.props.MasterModel.YoutubeUrl} className="fa fa-youtube-play" target="_blank"></a></li> : null
                                }
                            </ul>
                        </div>
                    </nav>
                </div>
                <header className="navbar mainMenu top-menu navbar-inverse">
                    <div className="container">
                        <div className="navbar-header">
                            <button type="button" className="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                                <span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>

                            </button>
                            <a className="navbar-brand" href="index.html">
                                <img data-src={require("./../Content/images/logo.png")} alt="First slide" src={require("./../Content/images/logo.png")} />
                            </a>
                        </div>
                        <nav className="navbar-collapse collapse navbar-right" role="navigation">
                            <ul className="nav navbar-nav">
                                <li className={this.IsCurrentRoute("/") ? "active" : ""}><Link to={'/'}>Home</Link></li>
                                <li className={this.IsCurrentRoute("/aboutus") ? "active" : ""} ><Link to={'/aboutus'}>About</Link></li>
                                <li className={this.IsCurrentRoute("/services") ? "active" : ""} ><Link to={'/services'}>Services</Link></li>
                                <li className={this.IsCurrentRoute("/contacts") ? "active" : ""}><Link to={'/contacts'}>Contacts</Link></li>
                            </ul>
                        </nav>
                    </div>

                </header>

                {this.props.children}

                { /* start Footer */}
                <footer id="footerArea">

                    <div className="container">
                        <div className="row">
                            <div className="col-sm-5">
                                <h3>About Us</h3>
                                {this.renderHtmlSafe(this.props.MasterModel.AboutUsShortText)}
                            </div>
                            <div className="col-sm-4">
                                <h3>Services</h3>
                                {this.renderHtmlSafe(this.props.MasterModel.ServicesShortText)}
                            </div>
                            <div className="col-sm-3">
                                <h3>Company Address </h3>
                                <ul className="list-unstyled">
                                    <li>
                                        <div><i className="fa fa-map-marker"></i>&nbsp;
                                            {this.renderHtmlSafe(this.props.MasterModel.CompanyAddressShortText1)}
                                        </div>
                                    </li>
                                    <li><p><i className="fa fa-phone"></i>&nbsp;{this.props.MasterModel.PhoneNumber}</p></li>
                                    <li><p><i className="fa fa-envelope"></i>&nbsp;<a href={"mailto:" + this.props.MasterModel.EmailAddress}>{this.props.MasterModel.EmailAddress}</a></p></li>
                                </ul>

                                <ul className="list-unstyled social">
                                    {
                                        this.props.MasterModel.DisplayFacebookLogo ?
                                            <li><a href={this.props.MasterModel.FacebookUrl} className="fa fa-facebook" target="_blank" ></a></li> :
                                            null}
                                    {
                                        this.props.MasterModel.DisplayTwitterLogo ?
                                            <li><a href={this.props.MasterModel.TwitterUrl} className="fa fa-twitter" target="_blank" ></a></li> : null
                                    }
                                    {
                                        this.props.MasterModel.DisplayGooglePlusLogo ?
                                            <li><a href={this.props.MasterModel.GooglePlusUrl} className="fa fa-google-plus" target="_blank"></a></li> : null
                                    }
                                    {
                                        this.props.MasterModel.DisplayLinkedinLogo ?
                                            <li><a href={this.props.MasterModel.LinkedInUrl} className="fa fa-linkedin" target="_blank"></a></li> : null
                                    }
                                    {
                                        this.props.MasterModel.DisplayYoutubeLogo ?
                                            <li><a href={this.props.MasterModel.YoutubeUrl} className="fa fa-youtube-play" target="_blank"></a></li> : null
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>

                    { /* start copyright */}
                    <div id="copyright">
                        <div className="container">

                            <p>&copy; {this.props.MasterModel.AllRightsReservedText}</p>

                            <ul className="list-unstyled">
                                <li><Link to={'/'}>Home</Link></li>
                                <li><Link to={'/aboutus'}>About</Link></li>
                                <li><Link to={'/services'}>Services</Link></li>
                                <li><Link to={'/contacts'}>Contacts</Link></li>
                            </ul>

                        </div>
                    </div>
                    { /* end copyright */}

                </footer>

            </div>;
    }

    private IsCurrentRoute(url): boolean {
        switch (url) {
            case "/aboutus":
            case "/services":
            case "/contacts":
                return document.location.href.toLowerCase().indexOf(url) > -1;
        }

        return document.location.href.toLowerCase().indexOf("/aboutus") == -1 &&
            document.location.href.toLowerCase().indexOf("/services") == -1 &&
            document.location.href.toLowerCase().indexOf("/contacts") == -1;
    }

    private renderHtmlSafe(str: string) {
        if (str == null) {
            return "";
        }
        return renderHtml(str);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/app/Components/layout.tsx